import { defineComponent as _defineComponent } from 'vue'
import SizeSelector from 'ah-common-lib/src/common/components/SizeSelector.vue';
import { FeeStatus } from 'ah-api-gateways/models/feesAndCharges/fees';
import {
  defineUseManagedListFilterProps,
  useManagedListFilter,
  UseManagedListFilterEmits,
} from 'ah-common-lib/src/listing';
import { computed } from 'vue';

interface OutstandingFeesFilters {
  query?: string;
  type: 'CLIENTS' | 'PARTNERS';
  feeStatus: FeeStatus[];
}

interface OutstandingFeesFiltersEmits extends UseManagedListFilterEmits<OutstandingFeesFilters> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'OutstandingFeesFilters',
  props: {
  ...defineUseManagedListFilterProps<OutstandingFeesFilters>(),
  hideOwnerType: {
    type: [Boolean, String],
    default: false,
  },
  hideSearch: {
    type: [Boolean, String],
    default: false,
  },
},
  setup(__props, { emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;

const feeStatusOptions = [
  {
    label: 'Ok',
    value: FeeStatus.OK,
  },
  {
    label: 'Overdue',
    value: FeeStatus.OVERDUE,
  },
  {
    label: 'Due',
    value: FeeStatus.DUE,
  },
];





const displayOwnerType = computed(() => props.hideOwnerType === false);

const displaySearch = computed(() => props.hideSearch === false);

const { filterData, sortAndPageData } = useManagedListFilter<OutstandingFeesFilters>({
  props,
  emit,
  filterKeys: [
    {
      key: 'query',
      getter: (filters) => (displaySearch.value && filters.value.query) || undefined,
      setter: (value: any, filters) => (filters.value.query = value),
    },
    {
      key: 'type',
      getter: (filters) => (displayOwnerType.value && filters.value.type) || undefined,
      setter: (value: any, filters) => (filters.value.type = value),
    },
    {
      key: 'feeStatus',
      getter: (filters) => filters.value.feeStatus || undefined,
      setter: (value: any, filters) => (filters.value.feeStatus = value),
    },
  ],
  sortAndPageKeys: [
    {
      key: 'pageSize',
      getter: (filters) => filters.value.pageSize || undefined,
      setter: (value, filters) => (filters.value.pageSize = value),
    },
  ],
});

return { __sfc: true,feeStatusOptions, emit, props, displayOwnerType, displaySearch, filterData, sortAndPageData, SizeSelector }
}

})